/**
 * Wishlist Header Link Component
 * Displays wishlist count in header
 */

import { ThemeEvents } from '../../entries/scripts/events';
import getLocalWishlist from '../../scripts/wishlist/getLocalWishlist';
import { Component } from '../../scripts/component';
import { debounce } from '../../scripts/utils';

class WishlistHeaderLink extends Component {
  countBadge = null;

  connectedCallback() {
    super.connectedCallback();
    this.countBadge = this.querySelector('.wishlist-count-badge');
    if (!this.countBadge) return;
    this.debouncedUpdateCount = debounce(this.updateCount.bind(this), 0);
    this.updateCount();

    // Listen for wishlist updates
    document.addEventListener('wishlist:updated', this.debouncedUpdateCount);
    document.addEventListener(ThemeEvents.cartUpdate, this.debouncedUpdateCount);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener('wishlist:updated', this.debouncedUpdateCount);
    document.removeEventListener(ThemeEvents.cartUpdate, this.debouncedUpdateCount);
  }

  updateCount() {
    if (!this.countBadge) return;
    let wishlist = getLocalWishlist();
    const count = wishlist.length;

    this.countBadge.textContent = count;
    if (count > 0) {
      this.countBadge.classList.add('has-items');
      this.countBadge.classList.remove('hidden');
    } else {
      this.countBadge.classList.remove('has-items');
      this.countBadge.classList.add('hidden');
    }
  }
}

if (!customElements.get('wishlist-header-link')) {
  customElements.define('wishlist-header-link', WishlistHeaderLink);
}
